import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { FeatureFlags } from '../../api/models/profile/profile-feature-flags.enum';
import { FeatureFlagGuardStrategy } from '../../feature-flag/feature-flag-guard-strategy';
import { AiPostureAccessService } from './ai-posture-access.service';

/**
 * Route strategy for `/ai-posture`: the page is reachable when the company's AISPM module is enabled OR the
 * prototype-embed flag (`DevAiPosturePrototype`) is on — see {@link AiPostureAccessService}. The route's
 * `CompanyVerificationGuard` (canMatch) has already waited for the profile, so its module plans are loaded.
 */
@Injectable({ providedIn: 'root' })
export class AiPostureRouteFlagStrategy implements FeatureFlagGuardStrategy {
    private readonly access = inject(AiPostureAccessService);

    canActivate(_state: RouterStateSnapshot, _next: ActivatedRouteSnapshot, _featureFlagName: string | FeatureFlags): Observable<boolean> {
        return this.access.selectCanView();
    }
}
